var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_icon",
    "data-name": "Download icon",
    transform: "translate(-202.471 -630)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10701",
    "data-name": "Rectangle 10701",
    width: 16,
    height: 16,
    transform: "translate(202.471 630)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32456",
    "data-name": "Group 32456",
    transform: "translate(-902.685 295.837)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "arrowAnimate"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 186",
    d: "M1116.12,344.577v-8.182",
    transform: "translate(-2.968)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 187",
    d: "M1117.172,345.508l-1.984,1.99-1.978-1.99",
    transform: "translate(-2.035 -2.92)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "",
    "data-name": "Path 188",
    d: "M1116.3,341.128h.639a2.5,2.5,0,0,1,2.5,2.5v3.319a2.494,2.494,0,0,1-2.494,2.5h-7.57a2.505,2.505,0,0,1-2.508-2.5v-3.32a2.5,2.5,0,0,1,2.5-2.5h.639",
    transform: "translate(0 -1.517)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.da540f432dc078fcc7f462401066fb61.svg";
export { ForwardRef as ReactComponent };